import React, { useState } from 'react';
import './Header.css';
import SearchIcon from '@material-ui/icons/Search';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import { Link } from 'react-router-dom';
import { useStateValue } from '../StateProvider';
import { auth, db } from '../Firebase';
import mercado from '../images/testlogo.png'

function Header() {
    const [{basket, user}, dispatch] = useStateValue();
    const [input, setInput] = useState();
    let length=0
    if(localStorage.getItem("basket")!=null){
        const basket2 = JSON.parse(localStorage.getItem("basket"))
        length=basket2.length
    }
    const addCategory=(value)=>{
        dispatch({type:"REMOVE_SEARCHITEM"})
        dispatch({
            type:'SET_CATEGORY',
            item:value,
        })
    }
    const handleAuthentication = ()=>{
        if(user){
            auth.signOut();
        }
    }
    const SearchItem = ()=>{
       dispatch({
           type:'SET_SEARCHITEM',
           item:input?.toLowerCase()
       })
        
    }
    return (
        <div className='header'>
            <Link to="/">
                <img className="header__logo"
                    src={mercado}
                />  
            </Link>
        <div className="header__search">
            <div className="dropdown">
                <button className="dropbtn">Categories
                </button>
                <div className="dropdown-content">
                    <div className="Category__item" onClick={()=>addCategory("fruits")}>Fruits</div>
                    <div className="Category__item" onClick={()=>addCategory("vegetables")}>Vegetables</div>
                    <div className="Category__item" onClick={()=>addCategory("others")}>Others</div>
                </div>

            </div>
            <input className="header__searchInput" onChange={(e)=>setInput(e.target.value)} type="text"/>
            <SearchIcon
            className="header__searchIcon"  onClick={SearchItem}/>
        </div>

        <div className="header__nav">
            <Link to={!user && '/login'}>
            <div  onClick={handleAuthentication} className='header__option'>
                <span className='header__optionLineOne'>Hello {user?user.email:'Guest'}</span>
                <span className='header__optionLineTwo'>{user ?'Sign Out':'Sign In'}</span>
            </div>
            </Link>
            <Link to='/orders'>
            <div className='header__option'>
                <span className='header__optionLineOne'>Returns</span>
                <span className='header__optionLineTwo'>& Orders</span>  
            </div>
            </Link>
            <Link to='/about'>
                <div className='header__option'>
                <span className='header__optionLineOne'>About</span>
                <span className='header__optionLineTwo'>Us</span> 
                </div>
            </Link>
            {user?.email=="gideonakosah37@gmail.com"? (<Link to='/admin'>
                <div className='header__option'>
                <span className='header__optionLineOne'>Admin</span>
                <span className='header__optionLineTwo'>Panel</span> 
                </div>
            </Link>) : ("")}
        </div>
        <Link to="/checkout">
            <div className="header__optionBasket">
                <ShoppingBasketIcon />
                <span className="header__optionLineTwo header__basketCount">{length}</span>
            </div>
        </Link>
        
        </div>
    )
}

export default Header
